import clickEventName from 'utils/DOM/clickEventName'

function addZipOnTabChange() {
  const zipValue = document.forms?.form?.zip?.value

  this.href = this.href + `${zipValue ? `?zip=${zipValue}` : ''}`
}
export default function () {
  $('body').on(clickEventName, '.Header__menu-link', addZipOnTabChange)
}
